<!-- 
 
chart.tooltip(false); // 关闭 tooltip
chart.tooltip({
  alwaysShow: false, // 当移出触发区域，是否仍显示提示框内容，默认为 false，移出触发区域 tooltip 消失，设置为 true 可以保证一直显示提示框内容
  offsetX: 0, // x 方向的偏移
  offsetY: 0, // y 方向的偏移
  triggerOn: [ 'touchstart', 'touchmove' ], // tooltip 出现的触发行为，可自定义，用法同 legend 的 triggerOn
  triggerOff: 'touchend', // 消失的触发行为，可自定义
  showTitle: false, // 是否展示标题，默认不展示
  showCrosshairs: false, // 是否显示辅助线，点图、路径图、线图、面积图默认展示
  crosshairsStyle: {
    stroke: 'rgba(0, 0, 0, 0.25)',
    lineWidth: 2
  }, // 配置辅助线的样式
  showTooltipMarker: true, // 是否显示 tooltipMarker
  tooltipMarkerStyle: {
    fill: '#fff' // 设置 tooltipMarker 的样式
  },
  background: {
    radius: 2,
    fill: '#1890FF',
    padding: [ 6, 10 ]
  }, // tooltip 内容框的背景样式
  titleStyle: {
    fontSize: 24,
    fill: '#fff',
    textAlign: 'start',
    textBaseline: 'top'
  }, // tooltip 标题的文本样式配置，showTitle 为 false 时不生效
  nameStyle: {
    fontSize: 24,
    fill: '#fff',
    textAlign: 'start',
    textBaseline: 'middle'
  }, // tooltip name 项的文本样式配置
  valueStyle: {
    fontSize: 24,
    fill: '#fff',
    textAlign: 'start',
    textBaseline: 'middle'
  }, // tooltip value 项的文本样式配置
  showItemMarker: true, // 是否展示每条记录项前面的 marker
  itemMarkerStyle: {
    radius: 7,
    symbol: 'circle',
    lineWidth: 2,
    stroke: '#fff'
  }, // 每条记录项前面的 marker 的样式配置
  custom: {Boolean}, // 是否自定义 tooltip 提示框
  onShow(obj) {
    // obj: { x, y, title, items }
  }, // tooltip 显示时的回调函数
  onHide(obj) {
    // obj: { x, y, title, items }
  }, // tooltip 隐藏时的回调函数
  onChange(obj) {
    // obj: { x, y, title, items }
  }, // tooltip 内容发生改变时的回调函数
  crosshairsType: {String}, // 辅助线的种类
  showXTip: {Boolean}, // 是否展示 X 轴的辅助信息
  showYTip: {Boolean}, // 是否展示 Y 轴的辅助信息
  xTip: {Object}/{Function}, // X 轴辅助信息的文本样式
  yTip: {Object}/{Function, // Y 轴辅助信息的文本样式
  xTipBackground: {Object}, // X 轴辅助信息的背景框样式
  yTipBackground: {Object}, // Y 轴辅助信息的背景框样式  
  snap: {Boolean} // 是否将辅助线准确定位至数据点
}); 
 
 -->
<template>
	<div class="container">
		<div class="chart bg-fff">
			<canvas id="mountNode"></canvas>
		</div>
	</div>
</template>
<script>
	function formatNumber(n) {
		return String(Math.floor(n * 100) / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};

	function parseTime(time, cFormat) {
		if (arguments.length === 0) {
			return null
		}
		const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
		let date
		if (typeof time === 'object') {
			date = time
		} else {
			if (('' + time).length === 10) time = parseInt(time) * 1000
			date = new Date(time)
		}
		const formatObj = {
			y: date.getFullYear(),
			m: date.getMonth() + 1,
			d: date.getDate(),
			h: date.getHours(),
			i: date.getMinutes(),
			s: date.getSeconds(),
			a: date.getDay()
		}
		const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
			let value = formatObj[key]
			// Note: getDay() returns 0 on Sunday
			if (key === 'a') {
				return ['日', '一', '二', '三', '四', '五', '六'][value]
			}
			if (result.length > 0 && value < 10) {
				value = '0' + value
			}
			return value || 0
		})
		return time_str
	};
	import {
		Toast,
		Icon,
		Popup,
		Picker
	} from "vant";
	export default {
		name: 'Test',
		components: {
			[Icon.name]: Icon,
			[Popup.name]: Popup,
			[Picker.name]: Picker,
		},
		data() {
			return {}
		},
		watch: {

		},
		created() {},
		methods: {
			/*获取下拉选择的项目名称*/
			getData() {
				return new Promise((resolve) => {
					let list = [{
						"resultContent": "118",
						"samplingTime": 1685343694000,
						"name": "收缩压",
					}];
					list.forEach(item => {
						//item.timestamp = item.samplingTime;
						item.cc = parseTime(item.samplingTime, '{y}-{m}-{d} {h}:{i}');
					})
					resolve(list)
				});
			},
		},
		created() {

		},
		computed: {

		},
		async mounted() {
			let data = await this.getData();
			var values = [];
			const ticks = [];
			for (var i = 0; i < data.length; i++) {
				ticks.push(data[i].samplingTime);
				// if (i < 3) {
				// 	values.push(data[i].date);
				// }
			}
			data.slice(-3).forEach((item) => {
				values.push(item.samplingTime);
			});
			var chart = new this.$F2.Chart({
				id: "mountNode",
				pixelRatio: window.devicePixelRatio,
				height: 300,
				padding: 40
			});
			chart.tooltip(false);
			chart.source(data, {
				samplingTime: {
					type: 'timeCat',
					tickCount:5,
					values: values, //初始
					ticks:ticks, //全部
					formatter:function(value){
						return parseTime(value, '{y}-{m}-{d} {h}:{i}').replace(' ', '\n')
					}
				}
			});
			chart
				.line()
				.position("samplingTime*resultContent");
			chart
				.point()
				.position("samplingTime*resultContent");
			//绘制文字
			data.forEach(function(obj) {
				chart.guide().text({
					position: [obj.samplingTime, obj.resultContent],
					content: obj.resultContent,
					top: true,
					style: {
						textAlign: "center",
						textBaseline: "bottom"
			 	},
			 	offsetY: -10
				});
			});
			chart.scrollBar({
				mode: 'x',
				xStyle: {
					backgroundColor: '#e8e8e8',
					fillerColor: '#808080',
					offsetY: -2
				}
			});
			chart.interaction("pan");
			chart.render();
			return chart;
		},
	}
</script>
<style type="text/css" scoped>
	.container {
		width: 100%;
		height: 100%;
	}

	.topSelect {
		width: 100%;
		padding: 0.266667rem;
	}

	#mountNode {
		width: 100%;
		height: 260px;
	}
</style>
